import type { AiPipelineAccent } from "./aiPipelineCatalog";

export type AiPipelineAccentStyle = {
  bannerBorder: string;
  bannerBg: string;
  bannerText: string;
  cardBorder: string;
  cardBg: string;
  titleText: string;
  mutedText: string;
  progressTrack: string;
  progressShimmer: string;
  stepActive: string;
  stepComplete: string;
  stepIdle: string;
  visualGlow: string;
  visualAccent: string;
  visualIcon: string;
  visualIconGlow: string;
};

/**
 * Text uses theme CSS variables (`--card-foreground`, `--muted-foreground`) so contrast
 * tracks the blended surface. Accent palette colors are for chrome/progress only.
 */
const semanticText = {
  bannerText: "text-card-foreground",
  titleText: "text-card-foreground",
  mutedText: "text-muted-foreground",
  stepActive: "text-card-foreground",
  stepComplete: "text-muted-foreground",
  stepIdle: "text-muted-foreground",
} as const;

export const aiPipelineAccentStyles: Record<AiPipelineAccent, AiPipelineAccentStyle> = {
  sky: {
    bannerBorder: "border-hue-sky/30",
    bannerBg: "bg-hue-sky/10",
    ...semanticText,
    cardBorder: "border-hue-sky/35",
    cardBg: "bg-card",
    progressTrack: "bg-hue-sky/20",
    progressShimmer: "from-hue-sky/50 via-hue-sky/80 to-hue-sky/50",
    visualGlow: "from-hue-sky/20 to-hue-sky/10",
    visualAccent: "bg-hue-sky",
    visualIcon: "text-card-foreground",
    visualIconGlow: "",
  },
  brand: {
    bannerBorder: "border-primary/30",
    bannerBg: "bg-primary/10",
    ...semanticText,
    cardBorder: "border-primary/35",
    cardBg: "bg-card",
    progressTrack: "bg-primary/20",
    progressShimmer: "from-primary/50 via-secondary/80 to-primary/50",
    visualGlow: "from-primary/20 to-secondary/10",
    visualAccent: "bg-primary",
    visualIcon: "text-card-foreground",
    visualIconGlow: "",
  },
  indigo: {
    bannerBorder: "border-hue-indigo/30",
    bannerBg: "bg-hue-indigo/10",
    ...semanticText,
    cardBorder: "border-hue-indigo/35",
    cardBg: "bg-card",
    progressTrack: "bg-hue-indigo/20",
    progressShimmer: "from-hue-indigo/50 via-hue-indigo/80 to-hue-indigo/50",
    visualGlow: "from-hue-indigo/20 to-hue-indigo/10",
    visualAccent: "bg-hue-indigo",
    visualIcon: "text-card-foreground",
    visualIconGlow: "",
  },
  emerald: {
    bannerBorder: "border-hue-emerald/30",
    bannerBg: "bg-hue-emerald/10",
    ...semanticText,
    cardBorder: "border-hue-emerald/35",
    cardBg: "bg-card",
    progressTrack: "bg-hue-emerald/20",
    progressShimmer: "from-hue-emerald/50 via-hue-emerald/80 to-hue-emerald/50",
    visualGlow: "from-hue-emerald/20 to-hue-emerald/10",
    visualAccent: "bg-hue-emerald",
    visualIcon: "text-card-foreground",
    visualIconGlow: "",
  },
  violet: {
    bannerBorder: "border-hue-violet/30",
    bannerBg: "bg-hue-violet/10",
    ...semanticText,
    cardBorder: "border-hue-violet/35",
    cardBg: "bg-card",
    progressTrack: "bg-hue-violet/20",
    progressShimmer: "from-hue-violet/50 via-hue-violet/80 to-hue-violet/50",
    visualGlow: "from-hue-violet/20 to-hue-violet/10",
    visualAccent: "bg-hue-violet",
    visualIcon: "text-card-foreground",
    visualIconGlow: "",
  },
};
